import classNames from 'classnames';
import { t } from 'ttag';

import { Modal } from '@ui/Modal';
import { Button } from '@ui/Button';

import s from './SubscriptionRequiredErrorModal.sss';

interface Props {
  className?: string,
  isOpen: boolean,
  secondTitle?: string | null,
  body?: string,
  onPay: () => void,
  onRequestClose: () => void,
}

export const SubscriptionRequiredErrorModal: React.FC<Props> = ({
  className,
  isOpen,
  body,
  secondTitle,
  onPay,
  onRequestClose,
}) => (
  <Modal
    className={classNames(s.modal, className)}
    isOpen={isOpen}
    withClose={false}
  >
    {!!body ? (
      <p
        className={s.message}
        dangerouslySetInnerHTML={{ __html: body }}
      />
    ) : (
      <p className={s.title}>
        {t`Це замовлення оформлено з підпискою, але оплата за підписку не пройшла.`}
      </p>
    )}

    {!!secondTitle && (
      <p className={s.description}>
        {t`Будь ласка, оплатіть спочатку підписку -`}
        &nbsp;
        <b>
          {secondTitle}
        </b>
      </p>
    )}

    <div className={s.buttons}>
      <Button
        className={s.button}
        theme="secondary"
        onClick={onRequestClose}
      >
        {t`Відміна`}
      </Button>

      <Button
        className={s.button}
        onClick={onPay}
      >
        {t`Оплатити`}
      </Button>
    </div>
  </Modal>
);
